export const VERSION_INFO = { tag: 'v2.48.16', branch: 'v2.48.16', commit: '6f94edd447f3fd42050a7e3352d2345fa8d7d9b0', date: 'Fri Apr 26 11:07:26 UTC 2024' }
